const slugify = string => {
  const a =
    "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;"
  const b =
    "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------"
  const p = new RegExp(a.split("").join("|"), "g")

  return string
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, "-and-") // Replace & with 'and'
    .replace(/[^\w\-]+/g, "") // Remove all non-word characters
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, "") // Trim - from end of text
}

const getAllLocationsNames = items => {
  const locationNames = []
  for (const item of items) {
    if (item.menu?.node?.locations?.length) {
      const locationName = item.menu.node.locations[0]
      if (!locationNames.includes(locationName)) {
        locationNames.push(item.menu.node.locations[0])
      }
    }
  }
  return locationNames
}

const recursiveAddChildItems = (items, parentDatabaseId = 0) => {
  const output = []
  for (const menuItem of items) {
    if (menuItem.parentDatabaseId === parentDatabaseId) {
      output.push({
        slug: slugify(menuItem.label),
        label: menuItem.label,
        url: menuItem.url === "#" ? null : menuItem.url,
        children: recursiveAddChildItems(
          items.filter(element => element.databaseId !== menuItem.databaseId),
          menuItem.databaseId
        ),
      })
    }
  }
  return output
}

/**
 *
 * @param {Array} allWpMenuNodes
 * @param {String} currentLanguageCode optional
 * @returns
 */
const createHierarchicalMenusFromAllWpMenuNodes = (
  allWpMenuNodes = [],
  currentLanguageCode = null,
  defaultLanguageCode = null
) => {
  const output = {}
  const allMenuItems = []
  const nodes = allWpMenuNodes.nodes ? allWpMenuNodes.nodes : allWpMenuNodes
  for (const wpMenuNode of nodes) {
    if (wpMenuNode?.menuItems?.nodes) {
      allMenuItems.push(...wpMenuNode.menuItems.nodes)
    }
  }
  const locationsNames = getAllLocationsNames(allMenuItems)

  const filteredLocationsNames = currentLanguageCode
    ? locationsNames.filter(element => {
        return (
          element.includes(`___${currentLanguageCode.toUpperCase()}`) ||
          (!element.includes(`___`) &&
            defaultLanguageCode === currentLanguageCode)
        )
      })
    : locationsNames
  for (const locationName of filteredLocationsNames) {
    const filteredLocationName = currentLanguageCode
      ? locationName.replace(`___${currentLanguageCode.toUpperCase()}`, "")
      : locationName
    output[filteredLocationName] = recursiveAddChildItems(
      allMenuItems.filter(item => {
        return (
          item.menu?.node?.locations?.length &&
          item.menu.node.locations[0] === locationName
        )
      })
    )
  }
  return output
}

const getCurrentHomepage = (homepages, languageCode) => {
  if (!languageCode || homepages.language?.code === languageCode) {
    return {
      uri: homepages.uri,
      language: homepages.language,
    }
  }
  if (homepages.translations?.length) {
    const translatedHomepage = homepages.translations.find(el => {
      return el.language.code === languageCode
    })
    return translatedHomepage ? translatedHomepage : null
  }
  return null
}

export {
  slugify,
  createHierarchicalMenusFromAllWpMenuNodes,
  getCurrentHomepage,
}
